//DIF Workflow
export const POST_WORKFLOW_REQUEST = "POST_WORKFLOW_REQUEST";
export const POST_WORKFLOW_SUCCESS = "POST_WORKFLOW_SUCCESS";
export const POST_WORKFLOW_FAILURE = "POST_WORKFLOW_FAILURE";